import {Component, OnInit} from '@angular/core'
import {FormBuilder, FormGroup, Validators} from '@angular/forms'
import {Store} from '@ngrx/store'
import {Observable} from 'rxjs'
import {Status, STATUS_GROUPING, STATUS_MAPPING} from 'src/constants/global-constants'
import {DashboardInfoAPIModel} from 'src/models/api.model'
import {DashboardService} from 'src/services/dashboard/dashboard.service'
import {FETCH_DASHBOARD_INFO} from 'src/store/action/dashboard.action'
import {AppState} from 'src/store/state/app.state'
import {MatSlideToggleChange} from "@angular/material/slide-toggle";
import {Router} from "@angular/router";
import {ADHOC_LOAD_BANKING_INFO, ADHOC_PROCESS_EXPENSES} from "../../store/action/adhoc.action";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  constructor(private store: Store<AppState>, private fb: FormBuilder, private dashboardService: DashboardService) {
    this.adhocExpenseProcessRequestForm = this.fb.group({
      extract: [false, Validators.required],
      process: [false, Validators.required],
      uploadExpenseReport: [false, Validators.required]
    })
  }

  adhocExpenseProcessRequestForm: FormGroup
  dashboardInfo$: Observable<DashboardInfoAPIModel>
  selectedUploadReportFile: File
  selectedTile: string | null = null;
  toggleDetails(tileKey: string): void {
    this.selectedTile = this.selectedTile === tileKey ? null : tileKey;
  }

  viewDetails(event: Event, tileKey: string): void {
    event.stopPropagation();
    this.toggleDetails(tileKey);
  }

  ngOnInit(): void {
    this.store.dispatch(FETCH_DASHBOARD_INFO())
    this.dashboardInfo$ = this.dashboardService.getDashboardInfoFromStore()
  }

  runAdhocBankingInfoLoad() {
    this.store.dispatch(ADHOC_LOAD_BANKING_INFO());
  }

  runAdhocExpensesProcessing() {
    const request = {
      ...this.adhocExpenseProcessRequestForm.value
    }

    this.store.dispatch(
      ADHOC_PROCESS_EXPENSES(
        {
          request,
          file: this.selectedUploadReportFile
        }
      ));
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.selectedUploadReportFile = input.files[0];
    }
  }

  resetConcurExtractToggle(event: MatSlideToggleChange): void {
    if (!event.checked) {
      this.adhocExpenseProcessRequestForm.patchValue({uploadConcurReport: false});
      this.selectedUploadReportFile = null;
    }
  }

  resetUploadToggle(event: MatSlideToggleChange): void {
    if (!event.checked) {
      this.selectedUploadReportFile = null;
    }else {
      this.adhocExpenseProcessRequestForm.patchValue({scheduleDate: ''});
    }
  }

  parseStatus(value): Status | undefined {
    return Object.values(Status).includes(value as Status) ? (value as Status) : undefined;
  }

  protected readonly Object = Object;
  protected readonly STATUS_MAPPING = STATUS_MAPPING;
  protected readonly STATUS_GROUPING = STATUS_GROUPING;
}
